module.exports = __webpack_public_path__ + "img/dynamic-2-r.a90d13cf.png";